export const ORGANIZATION = 'ORGANIZATION';
export const RETURN_URL = 'RETURN_URL';
export const IS_ESIA = 'IS_ESIA';
export const LAW_INTERFACE = 'LAW_INTERFACE';
export const LOCAL_STORE = 'LOCAL_STORE';
export const LOGIN = 'LOGIN';
